import React from 'react';
import { 
    Modal, 
} from 'components/lib';

const formFields = {
    activittyCompany: {
        label: '¿En qué campo se desenvuelve tu empresa?',
        type: 'select',
        // default: 'user',
        placeholder: 'Selecciona una opción',
        options: [
            {label: 'Agricultura y ganadería', value: 'Agricultura y ganadería'}, 
            {label: 'Alimentos y bebidas', value: 'Alimentos y bebidas'},
            {label: 'Comercio', value: 'Comercio'}, 
            {label: 'Construcción', value: 'Construcción'},
            {label: 'Cosmético', value: 'Cosmético'}, 
            {label: 'Educación', value: 'Educación'},
            {label: 'Energía y ambiente', value: 'Energía y ambiente'}, 
            {label: 'Finanzas y seguros', value: 'Finanzas y seguros'},
            {label: 'Hostelería y turismo', value: 'Hostelería y turismo'}, 
            {label: 'Legal', value: 'Legal'},
            {label: 'Logística y transporte', value: 'Logística y transporte'}, 
            {label: 'Marketing y comunicación', value: 'Marketing y comunicación'},
            {label: 'Ocio y deporte', value: 'Ocio y deporte'}, 
            {label: 'Química y materias primas', value: 'Química y materias primas'},
            {label: 'Salud', value: 'Salud'},
            {label: 'Tecnología', value: 'Tecnología'}, 
            {label: 'TIC', value: 'TIC'},
        ],
    },
    audience: {
        label: 'Cuánta audiencia tienes hasta ahora?',
        type: 'select',
        // default: 'user',
        placeholder: 'Selecciona una opción',
        options: [
            {label: 'Menoo o igual a 100', value: '<=100'}, 
            {label: 'Entre 101 - 1000', value: '>100 && <=1000'},
            {label: 'Entre 1001 y 10.000', value: '>1000 && <=10000'}, 
            {label: 'Entre 10.001 y 100.000', value: '>10001 && <=100000'},
            {label: 'Más de 100.000', value: '>100000'}, 
        ]
    },
}

export function Quiz1({ onboard, setOnboard, formData, btnShowAlert }){
    return (
        <Modal 
            logo={onboard}
            title={'¡Hola!'}
            subtitle={'Cuentanos más sobre tu empresa'}
            text={'De esta manera te guiaremos mejor al crear tu campaña'}
            form={formFields}
            next={true}
            type_form={onboard}
            onOnboard={setOnboard}
            onForm={formData}
            url={'/api/user/scope'}
            method='PUT'
            callback={() => console.log('testing')}
            btnShowAlert={btnShowAlert}
        />
    );
}